import { Avatar } from "@material-ui/core";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setChat } from "./features/chatSlice";
import db from "./firebase";
import "./SidebarChat.css";
import TextTruncate from "react-text-truncate";
import * as timeago from "timeago.js";

function SidebarChat({ id, chatName, chatCreator }) {


    const dispatch = useDispatch();
    const [chatInfo, setChatInfo] = useState([]);

    useEffect(() => {
        db.collection("chats")
            .doc(id)
            .collection("messages")
            .orderBy("timestamp", "desc")
            .onSnapshot((snapshot) =>
                setChatInfo(snapshot.docs.map((doc) => doc.data()))
            );
    }, [id]);


    return (
        <div
            onClick={() =>
                dispatch(
                    setChat({
                        chatId: id,
                        chatName: chatName,
                        chatCreator: chatCreator,
                    })
                )
            }
            className="sidebarChat"
        >
            <Avatar src={chatInfo[0]?.photo ? chatInfo[0]?.photo : `https://avatars.dicebear.com/api/initials/${chatName}.svg?options[chars]=1`} />
            <div className="sidebarChat__info">
                <h3>{chatName}</h3>
                {/* <p>{chatInfo[0]?.message}</p> */}
                <TextTruncate
                    line={2}
                    element="p"
                    truncateText="..."
                    text={chatInfo[0]?.message}
                // textTruncateChild={<a href="#">Read on</a>}
                />
                <small>
                    {chatInfo[0]?.timestamp ? timeago.format(new Date(chatInfo[0]?.timestamp?.toDate())) : `New Chat created.`}
                    {/* {moment(chatInfo[0]?.timestamp).toDate().fromNow()} */}
                </small>
            </div>
        </div>
    );
}

export default SidebarChat;
